// src/components/RegistrationForm.js
import React, { useState } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  Heading,
  Select,
  useToast
} from '@chakra-ui/react';
import { functions } from '../firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';
import axios from 'axios'; // 1. Import axios

// 2. Get the base URL from the environment variable
const API_BASE_URL = 'https://api-amg2dwk5ga-uc.a.run.app'

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    date_of_birth: '',
    gender: 'Male',
    phone_number: '',
    marital_status: 'Single',
    gotra: '',
    occupation: '',
    father_name: '',
    mother_name: '',
    origin_place: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const toast = useToast();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

   const handleSubmit = async (e) => {
    e.preventDefault();
    const phoneRegex = /^\d{10}$/; // This regex checks for exactly 10 digits
    if (!phoneRegex.test(formData.phone_number)) {
      setErrors({ phone_number: 'Phone number must be exactly 10 digits.' });
      return; // Stop the submission
    }
    setErrors({});
    setIsLoading(true);
    try {
      // 3. Use axios to call the specific API endpoint with the full URL
      const response = await axios.post(`${API_BASE_URL}/api/register`, formData);
      
      toast({
        title: 'Registration Successful.',
        description: response.data.message,
        status: 'success',
      });
    } catch (error) {
      toast({
        title: 'Registration Failed.',
        // Axios places the backend error message in error.response.data
        description: error.response?.data?.message || 'Something went wrong.',
        status: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box p={8} maxWidth="600px" borderWidth={1} borderRadius={8} boxShadow="lg" mx="auto" my={20}>
      <VStack as="form" spacing={4} onSubmit={handleSubmit}>
        <Heading>Join the Bagda Samaj Pragati Path</Heading>
        
        <FormControl isRequired>
          <FormLabel>Full Name</FormLabel>
          <Input name="name" placeholder="Enter your full name" onChange={handleChange} value={formData.name} />
        </FormControl>
        
        <FormControl isRequired isInvalid={!!errors.phone_number}>
          <FormLabel>Phone Number</FormLabel>
          <Input name="phone_number" type="tel" placeholder="Enter your 10-digit phone number" onChange={handleChange} value={formData.phone_number} />
        </FormControl>

        <FormControl isRequired>
            <FormLabel>Date of Birth</FormLabel>
            <Input name="date_of_birth" type="date" onChange={handleChange} value={formData.date_of_birth} />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Father's Name</FormLabel>
          <Input name="father_name" placeholder="Enter your father's name" onChange={handleChange} value={formData.father_name} />
        </FormControl>
        
        <FormControl isRequired>
          <FormLabel>Mother's Name</FormLabel>
          <Input name="mother_name" placeholder="Enter your mother's name" onChange={handleChange} value={formData.mother_name} />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Gender</FormLabel>
          <Select name="gender" onChange={handleChange} value={formData.gender}>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </Select>
        </FormControl>

         <FormControl isRequired>
          <FormLabel>Marital Status</FormLabel>
          <Select name="marital_status" onChange={handleChange} value={formData.marital_status}>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
            <option value="Divorced">Divorced</option>
            <option value="Widowed">Widowed</option>
          </Select>
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Gotra</FormLabel>
          <Input name="gotra" placeholder="Enter your Gotra" onChange={handleChange} value={formData.gotra} />
        </FormControl>

         <FormControl isRequired>
          <FormLabel>Occupation</FormLabel>
          <Input name="occupation" placeholder="e.g., Software Engineer, Business" onChange={handleChange} value={formData.occupation} />
        </FormControl>

         <FormControl isRequired>
          <FormLabel>Native Place (Village/City)</FormLabel>
          <Input name="origin_place" placeholder="Enter your native place" onChange={handleChange} value={formData.origin_place} />
        </FormControl>


        <Button
          type="submit"
          bg="blue.600" // Set a specific background color
            color="white"   // Set the text color
            _hover={{
        bg: 'blue.700', // Set a specific hover color
            }}
          width="full"
          mt={4}
          isLoading={isLoading}
        >
          Register
        </Button>
      </VStack>
    </Box>
  );
};

export default RegistrationForm;